.n{overflow:hidden;}